import React, { Component } from 'react';

export default class Navbar extends Component {
   render() {
    return (
      <div className="top-bar">
        <span className='my-name'>Steven Wing - Résumé</span>
        
        <button className='navButtons' onClick={(e) => window.location.href="https://projects.stevenwing.dev"}>
          View Portfolio
        </button>
      </div>

    )
  }
}
